import { TbArrowsLeftRight, TbQrcode } from "react-icons/tb";
import { MdOutlinePix } from "react-icons/md";
import { ShortcutCard } from "../../Atoms/ShortcutCard";
import { useAuth } from "../../../Contexts/AuthContext";

export const TransfersShortcutMenu = ({ onOpenInternalTransfer }) => {
  const { hasPermission } = useAuth();

  const items = [
    {
      label: "Entre contas",
      icon: TbArrowsLeftRight,
      onClick: onOpenInternalTransfer,
      permission: "transp2p",
    },
    {
      label: "Recebimento Pix",
      icon: TbQrcode,
      path: "/pix",
      search: "qrReceive=true",
      permission: "receivepix",
    },
    {
      label: "Pagamento Pix",
      icon: MdOutlinePix,
      path: "/pix",
      search: "newTransfer=true",
      permission: "paypix",
    },
  ];

  const visible = items.filter(
    (item) => !item.permission || hasPermission(item.permission)
  );

  if (!visible.length) return null;

  return (
    <section className="mb-5 min-w-0 overflow-hidden">
      <h2 className="dashboard-section-label mb-3">Transferir</h2>
      <div className="shortcut-scroll-row">
        {visible.map(({ label, icon, path, search, onClick, comingSoon }) => (
          <ShortcutCard
            key={label}
            to={path}
            search={search}
            onClick={onClick}
            icon={icon}
            label={label}
            disabled={comingSoon}
            badge={comingSoon ? "Em breve" : undefined}
          />
        ))}
      </div>
    </section>
  );
};
